export function formatBundleReplacementNumber(value) {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value || 0);
}

export function formatBundleReplacementUnits(value) {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value || 0);
}

export function formatBundleReplacementPercent(value) {
  return `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format((value || 0) * 100)}%`;
}

export function rowHasBundleReplacementException(row) {
  return (
    row.missingExecution ||
    row.missingOriginalComponent ||
    row.missingReplacement ||
    row.shiftPercent <= 0 ||
    row.shiftedBundleDemand > row.bundleComponentDemand + 0.001
  );
}

export function filterBundleReplacementRows(rows, { search = '', exceptionsOnly = false } = {}) {
  const normalizedSearch = search.trim().toLowerCase();
  return (rows || []).filter(row => {
    const matchesSearch =
      !normalizedSearch ||
      row.executionSku.toLowerCase().includes(normalizedSearch) ||
      row.originalComponentSku.toLowerCase().includes(normalizedSearch) ||
      row.replacementSku.toLowerCase().includes(normalizedSearch) ||
      row.executionProductName.toLowerCase().includes(normalizedSearch) ||
      row.originalComponentProductName.toLowerCase().includes(normalizedSearch) ||
      row.replacementProductName.toLowerCase().includes(normalizedSearch);

    const hasException = rowHasBundleReplacementException(row);
    return matchesSearch && (!exceptionsOnly || hasException);
  });
}

export function summarizeBundleReplacementRows(filteredRows) {
  const bundleCount = new Set(filteredRows.map(row => row.executionSku)).size;
  const shiftedUnits = filteredRows.reduce((sum, row) => sum + row.shiftedBundleDemand, 0);
  const componentUnits = filteredRows.reduce((sum, row) => sum + row.bundleComponentDemand, 0);
  const replacementCount = new Set(filteredRows.map(row => row.replacementSku)).size;
  const exceptionCount = filteredRows.filter(row => rowHasBundleReplacementException(row)).length;

  return {
    bundleCount,
    shiftedUnits,
    componentUnits,
    replacementCount,
    exceptionCount,
  };
}

export function buildBundleReplacementGroups(filteredRows, limit = 8) {
  const grouped = new Map();
  filteredRows.forEach(row => {
    const current = grouped.get(row.replacementSku);
    if (current) {
      current.shiftedUnits += row.shiftedBundleDemand;
      current.sourceCount += 1;
      return;
    }
    grouped.set(row.replacementSku, {
      replacementSku: row.replacementSku,
      replacementProductName: row.replacementProductName,
      shiftedUnits: row.shiftedBundleDemand,
      sourceCount: 1,
    });
  });
  return Array.from(grouped.values())
    .sort(
      (left, right) =>
        right.shiftedUnits - left.shiftedUnits ||
        left.replacementSku.localeCompare(right.replacementSku)
    )
    .slice(0, limit);
}

export function getBundleReplacementStatusLabel(row) {
  if (rowHasBundleReplacementException(row)) return 'Needs review';
  return 'Shift applied';
}
